import { RestrictedAccountObjectApiFacade } from '../restricted-account-object/restricted-account-object.api-facade';
import { Job } from './job.model';
import { Observable } from 'rxjs/Observable';
import { ApiRequestOptions } from '../../../core/services/api/request-options';
import { IJobFilters } from './job.reducer';
import { IFilteredResponse } from '../../../core/services/api/filtered-response.interface';
import { _throw } from 'rxjs/observable/throw';
import { of } from 'rxjs/observable/of';
import { isArray } from 'ionic-angular/util/util';
import { AuditLog } from '../audit-log/audit-log.model';
import { AuditLogPaginationModel } from '../audit-log/audit-log-pagination.model';
import { RequestMethod, Response } from '@angular/http';
import { JobFiltersToQueryConverter } from './job-filters-to-query-converter';
import { AuditLogDataHelper } from './audit-log-data-helper';

export class JobApiFacade extends RestrictedAccountObjectApiFacade<Job> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Job> {
        return this.GET(`/accounts/${accountId}/jobs/${id}`, options)
            .map(object => new Job(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Job>> {
        return this.CGET(`/accounts/${accountId}/jobs`, options)
            .map(objects => objects.map(object => new Job(object)));
    }

    search(accountId: string, filters: IJobFilters, options: ApiRequestOptions = new ApiRequestOptions()): Observable<IFilteredResponse<Job>> {
        const converter = new JobFiltersToQueryConverter();
        const query = converter.getQuery(filters);
        options.setQuery(query);

        return this.api.simpleGet(`/accounts/${accountId}/jobs`, options)
            .map(response => response.json())
            .map((response: IFilteredResponse<Job>) => {

                let r = response;

                if (isArray(r)) {
                    r = {
                        items: r,
                        total: r.length
                    };
                }
                return {
                    items: r.items.map(item => new Job(item)),
                    total: r.total
                };
            });
    }

    getFiltered(accountId: string, filters: IJobFilters, options?: ApiRequestOptions): Observable<IFilteredResponse<Job>> {
        return this.search(accountId, filters, options)
            .catch(error => {
                switch (error.status) {
                    case 404: {
                        return of({
                            items: [],
                            total: 0
                        });
                    }
                    default:
                        return _throw(error);
                }
            })
            .do(response => this.appFacade.objects.job.store.setTotal(response.total));
    }

    getAllAuditLogs(accountId: string, id: string, paginationModel: AuditLogPaginationModel): Observable<Array<AuditLog>> {
        return this.CGET(`/accounts/${accountId}/jobs/${id}/combinedaudit`, paginationModel.getApiRequestOptions())
            .map(objects => objects.map(object => new AuditLog(object)));
    }

    copy(jobId: string, newJob: Job): Observable<Response> {

        if (!jobId) {
            throw new Error('invalid jobId');
        }

        if (!newJob) {
            throw new Error('invalid newJob');
        }

        const request = this.api.createRequest(true, `/accounts/${newJob.account}/jobs/${jobId}/copy`, RequestMethod.Post);
        request.setBody({
            jobCopy: {
                jobDate: newJob.jobDate,
                jobType: newJob.jobType,
                jobStatus: newJob.jobStatus,
                accessGroup: newJob.accessGroup,
                assigneeId: newJob.assigneeId,
                fields: newJob.fields.map(f => f.id),
                files: newJob.files,
                reports: newJob.reports
            }
        });
        return request.execute();
    }

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.api-facade.ts